import { useCountries } from "@/modules/Beeswax/beeswax.hook";
import { useBeeswaxList } from "@/modules/BeeswaxList/beeswaxList.hook";
import { useForm } from "react-hook-form";

export function useGeoForm(data?: any) {
  const defaultValues = useDefaultValues(data);

  const rhForm = useForm<any>({
    defaultValues,
  });

  return { rhForm };
}

function useDefaultValues(data?: any) {
  return {
    country: null,
    state: null,
  };
}

export function useGeoData({
  isEdit,
  areFilters,
}: {
  isEdit: boolean;
  areFilters: Record<string, boolean>;
}) {
  const {
    data: zipList,
    isLoading: zipListLoading,
    isFetching: zipListFetching,
  } = useBeeswaxList(
    { queryParams: { type: "zip_code" }, options: { enabled: isEdit } },
    "withType"
  );
  const {
    data: countries,
    isLoading: countriesLoading,
    isFetching: countriesFetching,
  } = useCountries({ enabled: isEdit });
  return {
    zipList,
    zipListLoading: zipListLoading && zipListFetching,
    countries,
    countriesLoading: countriesLoading && countriesFetching,
  };
}
